import { render, staticRenderFns } from "./handwriteSuccess.vue?vue&type=template&id=18f07c42&scoped=true&"
import script from "./handwriteSuccess.vue?vue&type=script&lang=js&"
export * from "./handwriteSuccess.vue?vue&type=script&lang=js&"
import style0 from "./handwriteSuccess.vue?vue&type=style&index=0&id=18f07c42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f07c42",
  null
  
)

export default component.exports